import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react-v3'; 
import WorkflowsTable from './table/table.js';
import AppContext from "../../context/AppContext";
import ActivationRequired from "../../components/ActivationRequired";
import {getSidebarItemFromPageStage} from "../home/home";

class Workflows extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<ActivationRequired userStatus={this.context && this.context.userStatus}><WorkflowsTable /></ActivationRequired>}
                navigation={<SideBar activeHref="/workflows" items={getSidebarItemFromPageStage(this.context.pageStage)}/>}
                navigationOpen={true}
                onNavigationChange={() => {}}
                toolsHide={true}
            />
        );
    }
}

export default Workflows;
